import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/financialSituation'
import { getFinancialSituation as getFinancialSituationService } from 'services'

const {
  FINANCIAL_SITUATION_REQUEST,
  FINANCIAL_SITUATION_SUCCESS,
  FINANCIAL_SITUATION_ERROR
} = ACTION_TYPES

export function *getFinancialSituation() {
  try {
    const response = yield call(getFinancialSituationService)
    yield put({ type: FINANCIAL_SITUATION_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: FINANCIAL_SITUATION_ERROR, payload: err })
  }
}

export default function *watchFinancialSituation() {
  yield takeLatest(FINANCIAL_SITUATION_REQUEST, getFinancialSituation)
}
